import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, Form, Input, Space } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
import { formatCurrency } from "utils/number"
const service = new StoreSettingService();

const OrderSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const min_quantityValue = Form.useWatch('min_quantity', form);
    const min_amountValue = Form.useWatch('min_amount', form);
    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getOrderSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.saveOrderSetting(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (

        <Card>
            <Form
                form={form}
                name="basic"
                layout='vertical'
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                <Form.Item
                    label="Số lượng sản phẩm tối thiểu"
                    name="min_quantity"
                    rules={[{
                        required: true,

                    },

                    ]}
                    tooltip="Khách hàng phải đặt tối thiểu số sản phẩm"
                >
                    <InputNumber />
                </Form.Item>

                <Form.Item
                    label="Giá trị đơn hàng tối thiểu"
                    name="min_amount"
                    rules={[{
                        required: true,

                    },

                    ]}
                    tooltip="Khách hàng phải đặt tối thiểu số tiền"
                >
                    <InputNumber />
                </Form.Item>


                <Form.Item label="Diễn giải">

                    {(min_amountValue > 0 || min_quantityValue > 0) ?
                        <>

                            Khách hàng phải mua

                            {min_quantityValue > 0 &&
                                <> tối thiểu {min_quantityValue} sản phẩm
                                    {min_amountValue > 0 &&
                                        <> và </>
                                    }

                                </>
                            }
                            {min_amountValue > 0 &&
                                <>

                                    đơn hàng tối thiểu {formatCurrency(min_amountValue)}
                                </>

                            }
                        </> :
                        <>
                            Không giới hạn
                        </>
                    }





                </Form.Item>

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>

        </Card>
    )
}
export default OrderSetting;